export interface ApiRequestOptions {
  readonly method: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'OPTIONS' | 'HEAD' | 'PATCH';
  readonly path?: Record<string, unknown>;
  readonly url: string;
  readonly baseURL?: string;
  readonly headers?: Record<string, string | undefined>;
  readonly query?: Record<string, unknown>;
  readonly formData?: Record<string, unknown>;
  readonly body?: unknown;
  readonly mediaType?: string;
  readonly responseHeader?: string;
  readonly errors?: Record<number, string>;
  readonly shouldClearCacheEntry?: boolean;
}
